module.exports = __webpack_public_path__ + "static/media/logout.48871bb9.svg";